import { LocalMall } from '@mui/icons-material'
import SupplierEdit from './SupplierEdit'
import SupplierCreate from './SupplierCreate'
import SupplierList from './SupplierList'

const suppliersIndex = {
  icon: LocalMall,
  edit: SupplierEdit,
  create: SupplierCreate,
  list: SupplierList,
}

export default suppliersIndex
